import "@/App.css";
import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { Toaster } from "sonner";
import { AuthProvider } from "@/contexts/AuthContext";
import { SettingsProvider } from "@/contexts/SettingsContext";
import { CartProvider } from "@/contexts/CartContext";
import CartDrawer from "@/components/CartDrawer";
import Layout from "@/components/Layout";
import Music from "@/pages/Music";
import ReleaseDetail from "@/pages/ReleaseDetail";
import Artists from "@/pages/Artists";
import ArtistDetail from "@/pages/ArtistDetail";
import Merch from "@/pages/Merch";
import MerchSuccess from "@/pages/MerchSuccess";
import MyOrders from "@/pages/MyOrders";
import Video from "@/pages/Video";
import Blog from "@/pages/Blog";
import BlogDetail from "@/pages/BlogDetail";
import Playlists from "@/pages/Playlists";
import PlaylistDetail from "@/pages/PlaylistDetail";
import Tags from "@/pages/Tags";
import Contact from "@/pages/Contact";
import Login from "@/pages/Login";
import Admin from "@/pages/Admin";

function App() {
  return (
    <div className="App">
      <HelmetProvider>
      <AuthProvider>
        <SettingsProvider>
          <CartProvider>
            <BrowserRouter>
              <Toaster position="top-right" richColors closeButton />
              <CartDrawer />
              <Routes>
                <Route element={<LayoutRoute />}>
                  <Route path="/" element={<Music />} />
                  <Route path="/release/:id" element={<ReleaseDetail />} />
                  <Route path="/artists" element={<Artists />} />
                  <Route path="/artist/:id" element={<ArtistDetail />} />
                  <Route path="/merch" element={<Merch />} />
                  <Route path="/merch/success" element={<MerchSuccess />} />
                  <Route path="/my-orders" element={<MyOrders />} />
                  <Route path="/video" element={<Video />} />
                  <Route path="/blog" element={<Blog />} />
                  <Route path="/blog/:slug" element={<BlogDetail />} />
                  <Route path="/playlists" element={<Playlists />} />
                  <Route path="/playlists/:slug" element={<PlaylistDetail />} />
                  <Route path="/tags" element={<Tags />} />
                  <Route path="/contact" element={<Contact />} />
                  <Route path="/login" element={<Login />} />
                  <Route path="/admin" element={<Admin />} />
                </Route>
                {/* Legacy URL redirects — /llm.txt and /sitemap.xml were static
                    files in earlier iterations. They now live at /api/* and are
                    rebuilt live from the DB on every request. */}
                <Route path="/llm.txt" element={<ExternalRedirect to="/api/llm.txt" />} />
                <Route path="/sitemap.xml" element={<ExternalRedirect to="/api/sitemap.xml" />} />
              </Routes>
            </BrowserRouter>
          </CartProvider>
        </SettingsProvider>
      </AuthProvider>
      </HelmetProvider>
    </div>
  );
}

// Wrap children with Layout via outlet pattern
import { Outlet } from "react-router-dom";
function LayoutRoute() {
  return (
    <Layout>
      <Outlet />
    </Layout>
  );
}

// One-shot redirect to a same-origin URL that lives outside the SPA (e.g. an
// API endpoint that serves non-HTML content). Uses window.location.replace so
// the browser's back button doesn't loop.
function ExternalRedirect({ to }) {
  React.useEffect(() => {
    window.location.replace(to);
  }, [to]);
  return null;
}

export default App;
